import { render, staticRenderFns } from "./rfqs.vue?vue&type=template&id=2dc23e2a&scoped=true"
import script from "./rfqs.vue?vue&type=script&lang=js"
export * from "./rfqs.vue?vue&type=script&lang=js"
import style0 from "./rfqs.vue?vue&type=style&index=0&id=2dc23e2a&prod&scoped=true&lang=css"
import style1 from "./rfqs.vue?vue&type=style&index=1&id=2dc23e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc23e2a",
  null
  
)

export default component.exports